import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { baseURLProd } from '../../api';

const CalendarHook = () => {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [value, setValue] = useState(new Date());
    const [selectedData, setSelectedData] = useState([]);
    const [data, setData] = useState([]);
    const [registrationMessage, setRegistrationMessage] = useState('')
    const userId = localStorage.getItem('userId')
    
    useEffect(() => {
        const handleInitialLoad = async () => {
            const formData = new FormData();
            formData.append("user_id", userId);
            try {
                const response = await fetch(`${baseURLProd}new-show-calender`, {
                    method: "POST",
                    body: formData,
                });
    
                const data = await response.json();
                setData(data);
    
                const today = new Date();
                const formattedToday = formatDate(today);
    
                const todayEvents = [];
                Object.keys(data).forEach((moduleKey) => {
                    if (Array.isArray(data[moduleKey])) {
                        data[moduleKey].forEach((event) => {
                            if (event.date === formattedToday) {
                                todayEvents.push(event);
                            }
                        });
                    }
                });
    
                setSelectedData(todayEvents);
                setValue(today);
            } catch (error) {
                console.error("Error fetching calendar details:", error);
            }
        };
    
        handleInitialLoad();
    }, []);
    

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleDateClick = (date) => {
        const formattedDate = formatDate(date);
    
        const allEvents = [];
        Object.keys(data).forEach((moduleKey) => {
          if (Array.isArray(data[moduleKey])) {
            data[moduleKey].forEach((event) => {
              if (event.date === formattedDate) {
                allEvents.push(event);
              }
            });
          }
        });
    
        setSelectedData(allEvents);
        setValue(date);
      };

  useEffect(() => {
    handleDateClick(new Date());
  }, []); 
  
    const toggleModal = () => setShowModal(!showModal);
    const toggleModal2 = () => setShowModal2(!showModal2);

    const handleCalendar = () => {
        navigate('/calendar')
    }
    const handleClassDetail = async (event) => {
        const formData = new FormData();
        const { schedule_id, class: classname, type } = event;
    
        formData.append("schedule_id", schedule_id);
        formData.append("class", classname);
        formData.append("type", type);
    
        try {
            const response = await fetch(`${baseURLProd}class-details`, {
                method: "POST",
                body: formData,
            });
    
            const data = await response.json();
    
            if (data) {
                sessionStorage.setItem('classDetail', JSON.stringify(data.data[0]));
                navigate('/classdetails');
            } else {
                console.error("No data available");
            }
        } catch (error) {
            console.error("Error fetching class details:", error);
        }
    };
    

    const handleregisterClass = async () => {
        const selectedClassDetail = JSON.parse(sessionStorage.getItem('classDetail'))
        const formData = new FormData();
        formData.append("user_id", userId);
        formData.append("schedule_id", selectedClassDetail.schedule_id);
        formData.append("skill", selectedClassDetail.skill);
        formData.append("topic", selectedClassDetail.topics);
        formData.append("faculty", selectedClassDetail.faculty);
        try {
            const response = await fetch(`${baseURLProd}add-user-registration`, {
                method: "POST",
                body: formData,
            });

            const data = await response.json();
            setRegistrationMessage(data.message)
            setShowModal(false)
            setShowModal2(true)
        } catch (error) {
            console.error("Error fetching class details:", error);
        }
    }
    const handleBack = () => {
        navigate(-1);
    };
    return {
        handleCalendar, handleClassDetail, handleBack, toggleModal, showModal, value, setValue,
        selectedData, setSelectedData, data, handleDateClick, registrationMessage, handleregisterClass,
        showModal2, toggleModal2
    }
}

export default CalendarHook
